import { Outlet } from "react-router-dom"
import { useEffect, useState } from "react"
import RefundRequestPM from "../../views/refund/RefundRequestsPM"
import { getPmRefundApprovalPendingCount } from "../../redux/features/refundSlice"
import { useDispatch, useSelector } from "react-redux"

const RestrictionWrapper = () => {
  const dispatch = useDispatch()
  const { pmPendingCount } = useSelector((state) => state.refund) //WHILE DESTRUCTRING IT WILL RENDER EVEN ANY CHAGNE IN REFUND SLICE

  const [isPm, setIsPm] = useState(false)

  useEffect(() => {
    const role =
      JSON.parse(localStorage.getItem("cred"))?.profile?.role

    const isProjectManager = role === "Project Manager"

    setIsPm(isProjectManager)

    if (isProjectManager) {
      dispatch(getPmRefundApprovalPendingCount())
    }
  }, [dispatch,pmPendingCount])

//   console.log("pmPendingCount", pmPendingCount);
//   console.log("isPm", isPm);

  if (pmPendingCount > 0 && isPm) {
    return <RefundRequestPM />
  }

  return <Outlet />
}

export default RestrictionWrapper